type Pending = {
  time: number;
  resolve: () => void;
};

let pending: Pending | null = null;

export function ackSimulationTime(time: number | string): void {
  if (!pending || pending.time !== time) return;
  const p = pending;
  pending = null;
  p.resolve();
}

export function waitForSimulationTimeApplied(time: number): Promise<void> {
  if (pending) {
    pending.resolve();
    pending = null;
  }
  return new Promise((resolve) => {
    pending = { time, resolve };
  });
}

export function cancelPendingSimulationTimeAck(): void {
  if (pending) {
    pending.resolve();
    pending = null;
  }
}
